import hyRequest from '@/service';
import { IMonitor } from './type';

enum DashboardApi {
  getMonitorList = '/monitor/getMonitor',
  addFocusMonitor = '/monitor/addFocus',
  cancelFocusMonitor = '/monitor/cancelFocus'
}

// 获取监控列表
export function getMonitorList() {
  return hyRequest.post<IMonitor>({
    url: DashboardApi.getMonitorList
  });
}

// 添加关注监控
export function addFocusMonitor(data: { monitoringId: number }) {
  return hyRequest.post({
    url: DashboardApi.addFocusMonitor,
    data
  });
}

// 取消关注监控
export function cancelFocusMonitor(data: { monitoringId: number }) {
  return hyRequest.post({
    url: DashboardApi.cancelFocusMonitor,
    data
  });
}
